import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import {
  PublishStreamTestEventInput,
  PublishStreamTestEventResponse,
} from "../models/stream-test";

/** Redo-internal: publishes one event to both the redis and notice test channels. */
export const StreamTestGroup = HttpApiGroup.make("stream-test")
  .add(
    endpoint.merchant
      .post("publishStreamTestEvent", "/stream-test/publish")
      .setPayload(PublishStreamTestEventInput)
      .addSuccess(PublishStreamTestEventResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
